export enum AUTH_FIELDS {
	DATA = "data",
	CODE = "code",
	EMAIL_NEW = "newEmail",
	PASSWORD = "password",
	NICKNAME = "nickname",
	TOKEN_ACCESS = "token",
	IS_NEED_CHANGE = "isNeedChange",
	TOKEN_REFRESH = "refreshToken",
	AVATAR = "avatar",
	IS_GUEST = "isGuest",
	LOGIN = "email",
	ROLE = "role",
	USER_ID = "userId",
	REMEMBER_ME = "rememberMe",
	//
	ID = "id",
	SURNAME = "surname",
	DATE_REGISTRATION = "dateRegistration",
	FIRSTNAME = "firstname",
	PATRONYMIC = "patronymic",
	DATE_BIRTH = "dateBirth",
	EMAIL = "email",
	EMAIL_VERIFIED = "emailVerified",
	ALLOW_MARKETING = "allowMarketing",
	REF_CODE = "refCode",
	COUNTRY = "country",
	PHONE = "phone",
	SNILS = "snils",
	PASSPORT_SERIES = "passportSeries",
	PASSPORT_NUMBER = "passportNumber",
	PASSPORT_ISSUED = "passportIssued",
	PASSPORT_DATE_ISSUE = "passportDateIssue",
	INDEX = "index",
	LOCALITY = "locality",
	STREET = "street",
	NUMBER_HOUSE = "numberHouse",
	APARTMENT = "apartment",
	DIPLOMA = "diploma",
	ROLES = "roles",
	SOCIAL_NETWORK = "socialNetwork",
	MESSENGERS = "messengers",
	REGIONS = "regions",
	WORK_PLACES = "workPlaces",
	PURCHASED_PROGRAMS = "purchasedPrograms",
	STATUS = "status",
	EMAIL_ADMIN_PANEL = "emailAdminPanel",
	DESCRIPTION = "description",
	CITY = "city",
	PROF_INTERESTS = "profInterests",
	IS_PARTICIPATED_EVENT = "isParticipatedEvent",
	AVAILABLE_IN_SEARCH = "availableInSearch",
	CREATED_AT = "createdAt",
	NEAREST_REPRESENTATIVE = "nearestRepresentative",
	PHOTO = "photo",
	COUNTRY_CODE = "countryCode",
	IS_STUDENT = "isStudent",
	STUDENT_CARD = "studentCard",
	NATIONALITY = "nationality",
	PROGRAMS = "programs",
	STATUS_NAME = "statusName",
	IS_MEMBER_ASSOCIATION = "isMemberAssociation",
	DAY_END_ASSOCIATION = "dayEndAssociation",
	DATE_END_ASSOCIATION = "dateEndAssociation",
	IS_HAVE_FULL_REGISTRATION = "isHaveFullRegistration",
	IS_OPEN_WINDOW_CONFIRM = "isOpenWindowConfirm",
	DIPLOMA_FILES = "diplomaFiles",
	CHANGE_SURNAME_FILES = "changeSurnameFiles",
	STUDENT_CARDS = "studentCards",
	LEARNING_CERTIFICATES = "learningCertificates",
	HAS_REDIRECTED = "hasRedirected",
}
